<template>
  <div>
    <div class="tweet-outer">
      <div class="name">{{tweet.name}} <span class="maker">by {{makerName}}</span></div>
      <div class="price">¥{{tweet.price}} JPY</div>
      <div class="character">Character: <span class="tag" v-for="name in charaName">{{name}}</span></div>
      <div class="text">{{tweet.text}}</div>
      <div class="image-wrapper">
        <div v-if="tweet.img1" class="image" :style="`background-image: url(${tweet.img1})`"
            @click="previewModal=true,modalImg=tweet.img1">
        </div>
        <div v-if="tweet.img2" class="image" :style="`background-image: url(${tweet.img2})`"
            @click="previewModal=true,modalImg=tweet.img2">
        </div>
      </div>
      <div class="image-wrapper">
        <div v-if="tweet.img3" class="image" :style="`background-image: url(${tweet.img3})`"
            @click="previewModal=true,modalImg=tweet.img3">
        </div>
        <div v-if="tweet.img4" class="image" :style="`background-image: url(${tweet.img4})`"
            @click="previewModal=true,modalImg=tweet.img4">
        </div>
      </div>
      <btn class="request-btn" size="normal" type="primary" label="Request it!" @click="isRequestModal=true"></btn>
    </div>

    <Modal v-if="isRequestModal" @close="close">
      <div class="modal-body">
        <p class="modal-title">New Request</p>
        <p>Name: {{tweet.name}}</p>
        <p>total price: price({{tweet.price * howmany}}) + tips({{request.tips}}) + shippng fee({{request.shippingFee}})</p>
        <p>{{total()}} JPY</p>
        <NInput v-model="howmany"
          placeholder="how many want?(default 1)"
          type="number"
          class="m-t-20 n-input"
          @chargeRifleInput="nullCheckVal"
        >
        </NInput>
        <NInput v-model="request.shippingFee"
          placeholder="shipping fee(JPY)"
          type="number"
          class="m-t-20 n-input"
          @chargeRifleInput="nullCheckVal"
        >
        </NInput>
        <NInput v-model="request.tips"
          placeholder="tips(JPY)"
          type="number"
          class="m-t-20 n-input"
          @chargeRifleInput="nullCheckVal"
        >
        </NInput>
        <NSelect v-model="request.state" :options="stateObj" placeholder="state" class="n-input"
          @nullCheckVal="nullCheckVal"
        >
        </NSelect>
        <textarea
          v-model="request.message"
          class="textarea"
          placeholder="Enter your message"
        ></textarea>
        <div class="text-center">
          <btn v-if="isSend" size="normal" type="primary" label="Request!" @click="createRequest" :loading="loading"></btn>
          <btn v-else type="disabled" size="normal" label="Request!"></btn>
        </div>
      </div>
    </Modal>
    <!-- プレビューモーダル　 -->
    <modal v-if="previewModal" @close="close">
      <div class="modal-img" :style="`background-image: url(${modalImg})`"></div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import Btn from './Button.vue'
import Modal from './Modal.vue'
import Loading from './Loading.vue'
import NInput from './Input.vue'
import NSelect from './Select.vue'
import errHandling from '../mixins/apiErrorHandle.js'
export default {
  props: ['tweet'],
  components: {Btn, Modal, Loading, NInput, NSelect, errHandling},

  data() {
    return {
      loading: false,
      charaName: [],
      makerName: '',
      item_categoryName: '',
      isRequestModal: false,
      previewModal: false,
      isSend: false,
      stateObj: [
        {
          label: 'New Only',
          value: '0',
        },
        {
          label: 'Used ok(reasonable & easy get)',
          value: '1',
        },
      ],
      request: {},
      howmany: 1,
    }
  },

  created() {
    this.translateTags()
  },

  methods: {
    async translateTags() {
      const tagArray = ['maker', 'character', 'item_category']
      await Promise.all(tagArray.map(async (tag) => {
        if(!isNaN(this.tweet[tag]) && this.tweet[tag] !== null && tag !== 'character') {
          await this.getValue(this.tweet[tag], tag).then(data => {
            this[`${tag}Name`] = data
          })
        } else if(tag === 'character') {
          this.charaName = this.tweet.character.filter(chara => {
            this.getValue(chara, tag).then(data => {
              this.charaName.push(data)
              return data
            })
          })
        }
      })).then(data => {
        this.isLoading = false
      }).catch(err => {
        console.log(err)
      })
    },

    async getValue(val, api) {
      const getValueData = await axios.get(`public/${api}/tag/${val}`).then(data => {
        if(data.data.result && api == 'character') {
          if(data.data.result.ContentTitle !== null) {
            this.getValue(data.data.result.anime_id, 'content_title')
            this.isAnime = true
            this.animeId = data.data.result.anime_id
            return this.tagLangFilter(data.data.result)
          }
        } else if (data.data.result && api == 'content_title') {
          this.contentTitle = this.tagLangFilter(data.data.result)
        }
        return this.tagLangFilter(data.data.result)
      }).catch(err => {
        return false
      })
      return getValueData
    },

    tagLangFilter(val) {
      //優先度の高い言語順の配列作成(重複しても問題ない)
      let priorityArr = []
      if(this.$store.state.account.lang) {
        priorityArr = [this.$store.state.account.lang, 'ja', 'en']
      } else {
        priorityArr = [this.noAuthLang, 'ja', 'en']
      }
      let tag =''
      for (let i = 0; i<3; i++) {
        if(val[priorityArr[i]] !== null) {
          tag = val[priorityArr[i]]
          break
        }
      }
      return tag
    },

    createRequest() {
      if(this.howmany < 0) {
        return false
      }
      this.loading = true
      this.request.buyer_id = this.$store.state.account.id
      this.request.name = this.tweet.name
      this.request.makerSubmit = this.tweet.maker
      this.request.categorySubmit = this.tweet.item_category
      this.request.characterSubmit= JSON.stringify(this.tweet.character)
      this.request.anime_id= this.tweet.content_title
      this.request.price = Number(this.tweet.price) * this.howmany + Number(this.request.shippingFee)
      this.request.is_fee = false
      this.request.is_draft = 1
      this.request.img1 = this.tweet.img1? this.tweet.img1 : null
      this.request.img2 = this.tweet.img2? this.tweet.img2 : null
      this.request.img3 = this.tweet.img3? this.tweet.img3 : null
      this.request.img4 = this.tweet.img4? this.tweet.img4 : null
      axios.post('private/request/new', this.request).then((data) => {
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'this request is registered!'
        this.isNotice = true
        setTimeout(this.isNotice = false ,5000)
        this.$router.push('/home')
        this.loading = false
      }).catch((err) => {
        this.errorHandling(err)
      });
    },

    close() {
      this.isRequestModal = false
      this.previewModal = false
    },

    nullCheckVal() {
      let checkArr = ['tips', 'shippingFee', 'state']
      for(let i=0, len=checkArr.length; i < len; i++) {
        if(!this.request[checkArr[i]]) {
          this.isSend = false
          return false
        } else {
          this.isSend = true
        }
      }
    },

    total() {
      let total = Number(this.tweet.price) * this.howmany + Number(this.request.tips) + Number(this.request.shippingFee)
      return total
    }
  }
}
</script>

<style scoped>
.tweet-outer {
  border-radius: 5px;
  padding: 15px;
  max-width: 1000px;
  width: 80%;
  margin: auto;
  border: 1px solid #f5f5f5;
}

.name {
  font-size: 18px;
  font-weight: bold;
}

.maker {
  font-weight: normal;
}

.price {
  font-size: 18px;
  font-weight: bold;
}

.text {
  margin: 10px 0;
}

.image-wrapper {
  display: flex;
}

.image {
  width: 50%;
  height: 200px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.image:hover, .tweet-outer:hover {
  cursor: pointer;
  cursor: hand;
  box-shadow: 0px 0px 9px #f39939;
}

.maker {
  font-size: 14px;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  width: 100%;
}

.modal-body {
  padding: 20px;
}

.tag{
  padding: 5px;
  margin: 5px;
  color: #f39939;
  border-radius: 5px;
  font-size: 14px;
  border: 1px solid;
}

.request-btn {
  margin: 20px;
  text-align: center;
}

.modal-img {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
  width: 100%;
  height: 50vh;
}

.textarea {
  padding: 5px;
  border: 1px solid #707070;
  border-radius: 5px;
  width: 80vw;
  height: 100px;
  background: #fff;
  margin: 20px auto;
  max-width: 600px;
  display: block;
}

.n-input {
  width: 80vw;
  max-width: 600px;
  background: #fff;
  margin: 20px auto;
}

@media screen and (max-width: 720px) {
  .name {
    font-size: 16px;
    font-weight: bold;
  }

  .price {
    font-size: 14px;
    font-weight: normal;
  }

  .text {
    font-size: 14px;
  }

  .tweet-outer {
    background: #fff;
    border-radius: 5px;
    padding: 15px;
    max-width: 1000px;
    width: 100%;
    position: static;
    margin: auto;
    border: none;
    border-bottom: 2px solid rgb(235, 238, 240);
  }
}
</style>
